import { useEffect, useState } from 'react';
////////////////////////////////////////////////////ç
import { telegramWebApp } from '@/main';
import {
	ActivitiesService,
	AuthService,
	FriendsService,
} from '@/core/services';
import EndSeasonPopup from '@/app/shared/components/common/EndSeasonPopup/EndSeasonPopup';
import {
	Game,
	LoadingScreen,
	Onboarding,
	// OnboardingCollections,
	PlayOnMobile,
} from '@/app/shared/components/';
import { useCustomDispatch, useCustomSelector } from '@/core/redux/hooks';
import {
	setCounter,
	setDiamonds,
	setEarnPerTap,
	setIncrementByHour,
	setIncrementBySecond,
	setLastTimeIncrement,
	setMaxEnergy,
	setCurrentEnergy,
	setUser,
	increment,
	incrementEnergy,
	setEnergyTick,
	setLevel,
	setAvailableEnergyHack,
	setMultiTapLevel,
	setMultiTapCostLevelUp,
	setEnergyTankLevel,
	setEnergyTankCostLevel,
	setCategories,
	setNetworkSelected,
	setLevelRequeriments,
	setRewards,
	setLevelsStandings,
	setCountdownEnergyHack,
	decrementCountdownEnergyHack,
	setComboCards,
	setDailyRewards,
	setRewardCollected,
	setFriends,
	setAmountFriends,
	setEmail,
	decrementCountdownActivities,
	setYoutubeRewards,
	setPendingEarnAction,
	setPendingBuildAction,
	setCollections,
	setTotalCoinsGenerated,
	setNewFriendsReward,
	setFriendsReward,
	setTonWallet,
	setRPCEndpoint,
	setLevelCombo,
	setLevelComboList,
	setExchangeDiamondsRating,
	setAutoclickerTimerRemainingSeconds,
	decrementCountdownAutoclicker,
	setAutoclickerDiamondsRating,
	setIsAirdropUser,
	setVTNAmount,
	setNewDiamondsCollected,
	setSkins,
	setLeaderboardData,
	setSeasonData,
} from '@/core/redux/slices';
import { networkData } from '@/core/utils';
import { WelcomePopup } from '@/core/interfaces';
import { getHttpEndpoint } from '@orbs-network/ton-access';
import { setProducts } from '@/core/redux/slices/shop';

export const MainLayout: React.FC = () => {
	/*********************
	// #region Hooks
	**********************/
	const dispatch = useCustomDispatch();

	/*********************
	// #region Redux
	**********************/
	// const { counter } = useCustomSelector((state) => state.counter);
	const { increment_by_second, level, energy_tick } = useCustomSelector(
		(state) => state.counter
	);
	const { updatedLang } = useCustomSelector((state) => state.user);
	const { autoclickerTimerRemainingSeconds } = useCustomSelector(
		(state) => state.hacks
	);

	/*********************
	// #region Constants
	**********************/
	const { platform } = telegramWebApp;

	/*********************
	// #region States
	**********************/
	const [isLoaded, setIsLoaded] = useState<boolean>(false);
	const [firstTime, setFirstTime] = useState<boolean>(false);
	const [showOnboardingFirstPage, setShowOnboardingFirstPage] =
		useState<boolean>(false);
	const [welcomeDialog, setWelcomeDialog] = useState<WelcomePopup | null>(
		null
	);
	// Show popup always by default as requested
	const [showEndSeasonPopup, setShowEndSeasonPopup] = useState<boolean>(false);
	const [calledAuth, setCalledAuth] = useState<boolean>(false);

	/*********************
	// #region Observables
	**********************/
	useEffect(() => {
		const userData = telegramWebApp.initDataUnsafe.user;
		if (userData) {
			dispatch(
				setUser({
					id: userData.id,
					firstName: userData.first_name,
					lastName: userData.last_name || '',
					username: userData.username,
					photoUrl: userData.photo_url,
					isPremium: userData.is_premium,
				})
			);
		} else {
			dispatch(
				setUser({
					id: 1,
					firstName: 'John Doe',
					lastName: '',
					username: 'John Doe',
					photoUrl: '',
					isPremium: false,
				})
			);
		}

		authentificate(1);
		getRPCEndpoint();
		const seasonID = Number(-1);
		getLeaderboardData(seasonID);
		getSeasonsData();
	}, []);

	useEffect(() => {
		if (updatedLang === '') return;
		authentificate(0);
	}, [updatedLang]);

	useEffect(() => {
		if (!calledAuth) return;
		authentificate(0);
	}, [level]);

	/** Countdown energy hack */
	useEffect(() => {
		const interval = setInterval(() => {
			dispatch(decrementCountdownEnergyHack());
		}, 1000);

		return () => clearInterval(interval);
	}, []);

	useEffect(()=>{
		const interval = setInterval(()=>{
			const seasonID = Number(-1);
			getLeaderboardData(seasonID)
			getSeasonsData();
		}, 1000000);
		return () => clearInterval(interval);
	})

	/** Increment by second */
	useEffect(() => {
		const interval = setInterval(() => {
			dispatch(increment(increment_by_second));
		}, 1000);

		return () => clearInterval(interval);
	}, [increment_by_second]);

	/** Increment energy tick */
	useEffect(() => {
		const interval = setInterval(() => {
			dispatch(incrementEnergy(energy_tick));
		}, 1000);

		return () => clearInterval(interval);
	}, [energy_tick]);

	/** Decrement countdown activities */
	useEffect(() => {
		const interval = setInterval(() => {
			dispatch(decrementCountdownActivities());
		}, 1000);

		return () => clearInterval(interval);
	}, [dispatch]);

	/** Decrement countdown autoclicker */
	useEffect(() => {
		if (autoclickerTimerRemainingSeconds <= 0) return;
		const interval = setInterval(() => {
			dispatch(decrementCountdownAutoclicker());
		}, 1000);

		return () => clearInterval(interval);
	}, [autoclickerTimerRemainingSeconds]);

	useEffect(() => {
		if (firstTime) {
			setIsLoaded(true);
		}
	}, [firstTime]);

	useEffect(() => {
		if (!calledAuth) return;

		const extraCalls = async () => {
			await getDailyCombo();
			await getFriends();
		};

		extraCalls();
		const interval = setInterval(() => {
			setIsLoaded(true);
			setCalledAuth(false);
		}, 2000);

		return () => clearInterval(interval);
	}, [calledAuth]);

	/*********************
	// #region Functions
	**********************/
	const getRPCEndpoint = async () => {
		try {
			const endpoint = await getHttpEndpoint({
				network: 'testnet',
			});
			dispatch(setRPCEndpoint(endpoint));
		} catch (error) {
			console.error('Error getting RPC endpoint', error);
		}
	};
	const authentificate = async (isLaunching: number) => {
		try {
			const { isNewUser, isAirdropUser, userInfo } =
				await AuthService.authentificate({
					referral: telegramWebApp.initDataUnsafe.start_param || '',
					isLaunching: isLaunching,
				});

			const userSelectedNetwork = networkData.find(
				(element) => element.id == userInfo.selectedNetworkId
			);

			dispatch(setIsAirdropUser(isAirdropUser));
			dispatch(setVTNAmount(userInfo.vtnAmount));
			dispatch(setCounter(userInfo.previousCoins));
			dispatch(setDiamonds(userInfo.diamonds));
			dispatch(setLastTimeIncrement(userInfo.newCoinsCollected));
			dispatch(setNewDiamondsCollected(userInfo.newDiamondsCollected));
			dispatch(setFriendsReward(userInfo.friendsRewards));
			dispatch(setIncrementBySecond(userInfo.profitPerHour / 3600));
			dispatch(setIncrementByHour(userInfo.profitPerHour));
			dispatch(setTotalCoinsGenerated(userInfo.totalCoinsEarned));
			dispatch(setEarnPerTap(userInfo.earnPerTap));
			dispatch(setMaxEnergy(userInfo.maxEnergy));
			dispatch(setCurrentEnergy(userInfo.currentEnergy));
			dispatch(setEnergyTick(userInfo.energyPerSecond));
			dispatch(setCategories(userInfo.categories));
			dispatch(setLevelRequeriments(userInfo.levels.levels));
			dispatch(setLevel(userInfo.level));
			dispatch(setProducts(userInfo.products));
			dispatch(
				setAvailableEnergyHack(userInfo.availableEnergyHack.value)
			);
			dispatch(
				setCountdownEnergyHack(
					userInfo.availableEnergyHack.updateTimestamp
				)
			);
			dispatch(setNewFriendsReward(userInfo.gameConfig.newFriendReward));
			dispatch(setMultiTapLevel(userInfo.boostStars.level));
			dispatch(
				setMultiTapCostLevelUp(userInfo.boostStars.nextLevelPrice)
			);
			dispatch(setEnergyTankLevel(userInfo.boostEnergy.level));
			dispatch(
				setEnergyTankCostLevel(userInfo.boostEnergy.nextLevelPrice)
			);
			dispatch(
				setLevelCombo(userInfo.levels.levels[userInfo.level - 1].combo)
			);
			dispatch(setLevelComboList(userInfo.levelComboList));
			dispatch(
				setExchangeDiamondsRating(userInfo.exchangeDiamondsRating)
			);
			dispatch(
				setExchangeDiamondsRating(userInfo.exchangeDiamondsRating)
			);
			dispatch(
				setAutoclickerTimerRemainingSeconds(
					userInfo.autoclickerTimerRemainingSeconds
				)
			);
			dispatch(
				setAutoclickerDiamondsRating(userInfo.autoclickerDiamondsRating)
			);
			dispatch(setSkins(userInfo.skins));

			if (userSelectedNetwork) {
				dispatch(setNetworkSelected(userSelectedNetwork));
			} else {
				dispatch(
					setNetworkSelected({
						id: 1,
						name: 'Ethereum',
						image: 'https://img.vottun.tech/6b1befd5-fb7d-41d0-a2ae-fae7a10f6504/ethereum-cryptocurrency-icon-512x512-u1g6py59.png',
					})
				);
			}

			dispatch(
				setLevelsStandings([
					{
						name: 'Genin (下忝)',
						image: 'https://img.vottun.tech/6b1befd5-fb7d-41d0-a2ae-fae7a10f6504/genin.webp',
						level: 1,
						requiredPoints: 0,
						standing: [
							{
								username: 'PepeLuis',
								gainsPerHour: 32010,
								position: 1,
							},
							{
								username: 'Arturo',
								gainsPerHour: 31500,
								position: 2,
							},
							{
								username: 'Armando',
								gainsPerHour: 30150,
								position: 3,
							},
							{
								username: 'Cuccitini',
								gainsPerHour: 28700,
								position: 4,
							},
							{
								username: 'Alberto',
								gainsPerHour: 27500,
								position: 5,
							},
							{
								username: 'Alexia',
								gainsPerHour: 27400,
								position: 6,
							},
							{
								username: 'Berta',
								gainsPerHour: 26510,
								position: 7,
							},
							{
								username: 'Francisco',
								gainsPerHour: 25400,
								position: 8,
							},
							{
								username: 'Serginho',
								gainsPerHour: 25100,
								position: 9,
							},
							{
								username: 'BalbyMora',
								gainsPerHour: 24900,
								position: 10,
							},
						],
					},
					{
						name: 'Chūnin (中忝)',
						image: 'https://img.vottun.tech/6b1befd5-fb7d-41d0-a2ae-fae7a10f6504/chunin.webp',
						level: 2,
						requiredPoints: 5000,
						standing: [
							{
								username: 'PepeLuis',
								gainsPerHour: 32010,
								position: 1,
							},
							{
								username: 'Arturo',
								gainsPerHour: 31500,
								position: 2,
							},
							{
								username: 'Armando',
								gainsPerHour: 30150,
								position: 3,
							},
							{
								username: 'Cuccitini',
								gainsPerHour: 28700,
								position: 4,
							},
							{
								username: 'Alberto',
								gainsPerHour: 27500,
								position: 5,
							},
							{
								username: 'Alexia',
								gainsPerHour: 27400,
								position: 6,
							},
							{
								username: 'Berta',
								gainsPerHour: 26510,
								position: 7,
							},
							{
								username: 'Francisco',
								gainsPerHour: 25400,
								position: 8,
							},
							{
								username: 'Serginho',
								gainsPerHour: 25100,
								position: 9,
							},
							{
								username: 'BalbyMora',
								gainsPerHour: 24900,
								position: 10,
							},
						],
					},
					{
						name: 'Jŝnin (上忝)',
						image: 'https://img.vottun.tech/6b1befd5-fb7d-41d0-a2ae-fae7a10f6504/jonin.webp',
						level: 3,
						requiredPoints: 25000,
						standing: [
							{
								username: 'PepeLuis',
								gainsPerHour: 32010,
								position: 1,
							},
							{
								username: 'Arturo',
								gainsPerHour: 31500,
								position: 2,
							},
							{
								username: 'Armando',
								gainsPerHour: 30150,
								position: 3,
							},
							{
								username: 'Cuccitini',
								gainsPerHour: 28700,
								position: 4,
							},
							{
								username: 'Alberto',
								gainsPerHour: 27500,
								position: 5,
							},
							{
								username: 'Alexia',
								gainsPerHour: 27400,
								position: 6,
							},
							{
								username: 'Berta',
								gainsPerHour: 26510,
								position: 7,
							},
							{
								username: 'Francisco',
								gainsPerHour: 25400,
								position: 8,
							},
							{
								username: 'Serginho',
								gainsPerHour: 25100,
								position: 9,
							},
							{
								username: 'BalbyMora',
								gainsPerHour: 24900,
								position: 10,
							},
						],
					},
					{
						name: 'Ashigaru (足軽)',
						image: 'https://img.vottun.tech/6b1befd5-fb7d-41d0-a2ae-fae7a10f6504/ashigaru.webp',
						level: 4,
						requiredPoints: 100000,
						standing: [
							{
								username: 'PepeLuis',
								gainsPerHour: 32010,
								position: 1,
							},
							{
								username: 'Arturo',
								gainsPerHour: 31500,
								position: 2,
							},
							{
								username: 'Armando',
								gainsPerHour: 30150,
								position: 3,
							},
							{
								username: 'Cuccitini',
								gainsPerHour: 28700,
								position: 4,
							},
							{
								username: 'Alberto',
								gainsPerHour: 27500,
								position: 5,
							},
							{
								username: 'Alexia',
								gainsPerHour: 27400,
								position: 6,
							},
							{
								username: 'Berta',
								gainsPerHour: 26510,
								position: 7,
							},
							{
								username: 'Francisco',
								gainsPerHour: 25400,
								position: 8,
							},
							{
								username: 'Serginho',
								gainsPerHour: 25100,
								position: 9,
							},
							{
								username: 'BalbyMora',
								gainsPerHour: 24900,
								position: 10,
							},
						],
					},
					{
						name: 'Rŝnin (浪人)',
						image: 'https://img.vottun.tech/6b1befd5-fb7d-41d0-a2ae-fae7a10f6504/ronin.webp',
						level: 5,
						requiredPoints: 1000000,
						standing: [
							{
								username: 'PepeLuis',
								gainsPerHour: 32010,
								position: 1,
							},
							{
								username: 'Arturo',
								gainsPerHour: 31500,
								position: 2,
							},
							{
								username: 'Armando',
								gainsPerHour: 30150,
								position: 3,
							},
							{
								username: 'Cuccitini',
								gainsPerHour: 28700,
								position: 4,
							},
							{
								username: 'Alberto',
								gainsPerHour: 27500,
								position: 5,
							},
							{
								username: 'Alexia',
								gainsPerHour: 27400,
								position: 6,
							},
							{
								username: 'Berta',
								gainsPerHour: 26510,
								position: 7,
							},
							{
								username: 'Francisco',
								gainsPerHour: 25400,
								position: 8,
							},
							{
								username: 'Serginho',
								gainsPerHour: 25100,
								position: 9,
							},
							{
								username: 'BalbyMora',
								gainsPerHour: 24900,
								position: 10,
							},
						],
					},
					{
						name: 'Samurai (依)',
						image: 'https://img.vottun.tech/6b1befd5-fb7d-41d0-a2ae-fae7a10f6504/samurai.webp',
						level: 6,
						requiredPoints: 2000000,
						standing: [
							{
								username: 'PepeLuis',
								gainsPerHour: 32010,
								position: 1,
							},
							{
								username: 'Arturo',
								gainsPerHour: 31500,
								position: 2,
							},
							{
								username: 'Armando',
								gainsPerHour: 30150,
								position: 3,
							},
							{
								username: 'Cuccitini',
								gainsPerHour: 28700,
								position: 4,
							},
							{
								username: 'Alberto',
								gainsPerHour: 27500,
								position: 5,
							},
							{
								username: 'Alexia',
								gainsPerHour: 27400,
								position: 6,
							},
							{
								username: 'Berta',
								gainsPerHour: 26510,
								position: 7,
							},
							{
								username: 'Francisco',
								gainsPerHour: 25400,
								position: 8,
							},
							{
								username: 'Serginho',
								gainsPerHour: 25100,
								position: 9,
							},
							{
								username: 'BalbyMora',
								gainsPerHour: 24900,
								position: 10,
							},
						],
					},
					{
						name: 'Hatamoto Samurai (旗本依)',
						image: 'https://img.vottun.tech/6b1befd5-fb7d-41d0-a2ae-fae7a10f6504/hatamoto.webp',
						level: 7,
						requiredPoints: 10000000,
						standing: [
							{
								username: 'PepeLuis',
								gainsPerHour: 32010,
								position: 1,
							},
							{
								username: 'Arturo',
								gainsPerHour: 31500,
								position: 2,
							},
							{
								username: 'Armando',
								gainsPerHour: 30150,
								position: 3,
							},
							{
								username: 'Cuccitini',
								gainsPerHour: 28700,
								position: 4,
							},
							{
								username: 'Alberto',
								gainsPerHour: 27500,
								position: 5,
							},
							{
								username: 'Alexia',
								gainsPerHour: 27400,
								position: 6,
							},
							{
								username: 'Berta',
								gainsPerHour: 26510,
								position: 7,
							},
							{
								username: 'Francisco',
								gainsPerHour: 25400,
								position: 8,
							},
							{
								username: 'Serginho',
								gainsPerHour: 25100,
								position: 9,
							},
							{
								username: 'BalbyMora',
								gainsPerHour: 24900,
								position: 10,
							},
						],
						myPosition: {
							username: 'Nomad3v.eth',
							gainsPerHour: 450000,
							position: 240,
						},
					},
					{
						name: 'Sensei (先生)',
						image: 'https://img.vottun.tech/6b1befd5-fb7d-41d0-a2ae-fae7a10f6504/senseibg.webp',
						level: 8,
						requiredPoints: 50000000,
						standing: [
							{
								username: 'PepeLuis',
								gainsPerHour: 32010,
								position: 1,
							},
							{
								username: 'Arturo',
								gainsPerHour: 31500,
								position: 2,
							},
							{
								username: 'Armando',
								gainsPerHour: 30150,
								position: 3,
							},
							{
								username: 'Cuccitini',
								gainsPerHour: 28700,
								position: 4,
							},
							{
								username: 'Alberto',
								gainsPerHour: 27500,
								position: 5,
							},
							{
								username: 'Alexia',
								gainsPerHour: 27400,
								position: 6,
							},
							{
								username: 'Berta',
								gainsPerHour: 26510,
								position: 7,
							},
							{
								username: 'Francisco',
								gainsPerHour: 25400,
								position: 8,
							},
							{
								username: 'Serginho',
								gainsPerHour: 25100,
								position: 9,
							},
							{
								username: 'BalbyMora',
								gainsPerHour: 24900,
								position: 10,
							},
						],
					},
					{
						name: 'Daimyŝ Sensei (大坝先生)',
						image: 'https://img.vottun.tech/6b1befd5-fb7d-41d0-a2ae-fae7a10f6504/daimyobg.webp',
						level: 9,
						requiredPoints: 100000000,
						standing: [
							{
								username: 'PepeLuis',
								gainsPerHour: 32010,
								position: 1,
							},
							{
								username: 'Arturo',
								gainsPerHour: 31500,
								position: 2,
							},
							{
								username: 'Armando',
								gainsPerHour: 30150,
								position: 3,
							},
							{
								username: 'Cuccitini',
								gainsPerHour: 28700,
								position: 4,
							},
							{
								username: 'Alberto',
								gainsPerHour: 27500,
								position: 5,
							},
							{
								username: 'Alexia',
								gainsPerHour: 27400,
								position: 6,
							},
							{
								username: 'Berta',
								gainsPerHour: 26510,
								position: 7,
							},
							{
								username: 'Francisco',
								gainsPerHour: 25400,
								position: 8,
							},
							{
								username: 'Serginho',
								gainsPerHour: 25100,
								position: 9,
							},
							{
								username: 'BalbyMora',
								gainsPerHour: 24900,
								position: 10,
							},
						],
					},
					{
						name: 'Shogun Sensei (将軝先生)',
						image: 'https://img.vottun.tech/6b1befd5-fb7d-41d0-a2ae-fae7a10f6504/shogunbg.webp',
						level: 10,
						requiredPoints: 1000000000,
						standing: [
							{
								username: 'PepeLuis',
								gainsPerHour: 32010,
								position: 1,
							},
							{
								username: 'Arturo',
								gainsPerHour: 31500,
								position: 2,
							},
							{
								username: 'Armando',
								gainsPerHour: 30150,
								position: 3,
							},
							{
								username: 'Cuccitini',
								gainsPerHour: 28700,
								position: 4,
							},
							{
								username: 'Alberto',
								gainsPerHour: 27500,
								position: 5,
							},
							{
								username: 'Alexia',
								gainsPerHour: 27400,
								position: 6,
							},
							{
								username: 'Berta',
								gainsPerHour: 26510,
								position: 7,
							},
							{
								username: 'Francisco',
								gainsPerHour: 25400,
								position: 8,
							},
							{
								username: 'Serginho',
								gainsPerHour: 25100,
								position: 9,
							},
							{
								username: 'BalbyMora',
								gainsPerHour: 24900,
								position: 10,
							},
						],
					},
				])
			);

			dispatch(setRewards(userInfo.rewards));
			dispatch(setYoutubeRewards(userInfo.youtubeRewards));
			dispatch(setDailyRewards(userInfo.dailyRewards));
			dispatch(setEmail({ email: userInfo.email }));
			dispatch(setPendingEarnAction(userInfo.pendingActions.earnAction));
			dispatch(setCollections(userInfo.collections));
			dispatch(setTonWallet(userInfo.tonWallet));

			userInfo.gameConfig.showOnboardingPageZero &&
				setShowOnboardingFirstPage(
					userInfo.gameConfig.showOnboardingPageZero
				);

			userInfo.gameConfig.welcomePopup &&
				setWelcomeDialog(userInfo.gameConfig.welcomePopup);

			isNewUser && setFirstTime(isNewUser);

			isAirdropUser && dispatch(setIsAirdropUser(isAirdropUser));

			setCalledAuth(true);
		} catch (error: any) {
			let errorMessage = 'We cannot connect.';

			if (error.response) {
				errorMessage += ` Server responded with status ${
					error.response.status
				}: ${error.response.data?.message || error.response.data}`;
			} else if (error.request) {
				errorMessage += ' No response received from server.';
			} else {
				errorMessage += ` ${error.message}`;
			}

			console.error('Error details:', error);
		}
	};
	const getLeaderboardData = async(seassionId: Number)=>{
		try{
			const response = await AuthService.leaderboard(seassionId);
			dispatch(setLeaderboardData(response.userInfo));
		}catch(error:any){
			console.error('Error details:', error);
		}
	}
	const getSeasonsData = async()=>{
		try{
			const response = await AuthService.fetchSeasons();
			dispatch(setSeasonData(response.seasons));

			// Decide whether to show the end season popup.
			// We show it when there is at least one season and it's not active (isActive === false)
			// but we must ignore the infinite season IDs: 9 for int and 5 for live.
			try {
				const seasons = response.seasons?.seasons || [];
				if (seasons.length > 0) {
					const first = seasons[0];
					const env = (process.env.VITE_ENV_APP || '').toLowerCase();
					const isInfiniteSeason =
						(env === 'int' && first.id === 9) || (env === 'live' && first.id === 5);

					// Determine finished by isActive OR endDate in the past
					let finished = false;
					if (typeof first.isActive === 'boolean') {
						finished = !first.isActive;
					}
					if (!finished && first.endDate) {
						try {
							const endTs = new Date(first.endDate).getTime();
							if (!isNaN(endTs) && endTs < Date.now()) finished = true;
						} catch {}
					}

					console.debug('Seasons fetched:', { first, env, isInfiniteSeason, finished });
					// allow forcing popup in dev via env var
					const forcePopup = process.env.VITE_FORCE_END_SEASON_POPUP === 'true';
					if ((forcePopup || (!isInfiniteSeason && finished))) {
						setShowEndSeasonPopup(true);
					} else {
						setShowEndSeasonPopup(false);
					}
				}
			} catch (err) {
				console.warn('End season popup check failed', err);
			}
		}catch(error:any){
			console.error('Error details:', error);
		}
	}
	const getDailyCombo = async () => {
		try {
			const response = await ActivitiesService.getDailyCombo();

			dispatch(
				setComboCards({
					comboCards: response.userComboCards,
				})
			);
			dispatch(setRewardCollected(response.rewardCollected));

			if (
				response.userComboCards.length === 3 &&
				!response.rewardCollected
			) {
				dispatch(setPendingBuildAction(true));
			}
		} catch (error: any) {
			console.error('Error details:', error);
		}
	};

	const getFriends = async () => {
		try {
			const response = await FriendsService.getFriends();

			dispatch(setFriends(response));
			dispatch(setAmountFriends(response.length));
		} catch (error: any) {
			let errorMessage = 'We cannot connect.';

			if (error.response) {
				errorMessage += ` Server responded with status ${
					error.response.status
				}: ${error.response.data?.message || error.response.data}`;
			} else if (error.request) {
				errorMessage += ' No response received from server.';
			} else {
				errorMessage += ` ${error.message}`;
			}

			console.error('Error details:', error);
		}
	};

	/*********************
	// #region Template
	**********************/
	if (
		platform === 'android' ||
		platform === 'ios' ||
		platform === 'android_x' ||
		process.env.VITE_ENV_APP === 'dev' ||
		process.env.VITE_ENV_APP === 'int'
	) {
		return (
			<div className={`bg-page-gradient min-h-dvh`}>
				{!isLoaded ? (
					<LoadingScreen />
				) : firstTime ? (
					<Onboarding
						action={setFirstTime}
						showOnboardingPageZero={showOnboardingFirstPage}
						welcomePopup={welcomeDialog}
					/>
				) : (
					<Game />
				)}
				{/* End season popup shown on first load when applicable */}
				<EndSeasonPopup isOpen={showEndSeasonPopup} onClose={setShowEndSeasonPopup} />
			</div>
		);
	} else {
		return <PlayOnMobile />;
	}
};
